import React from 'react';

import PaymentTable from '../PaymentTable';
import { connect } from 'react-redux';
import { toggleActivation } from 'app/redux/modules/dwellings';
import CardHeader from '@mui/material/CardHeader';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from 'app/common/button';
import i18n from 'app/common/i18n';

const StatusPreview = (props) => {
  const {
    dwelling,
    approved,
    setDwelling,
    token,
    onToggleActive,
    onExtend,
    mutationOptions
  } = props;

  function updateDwelling({ listingType }) {
    setDwelling((prev) => ({
      ...prev,
      listingType
    }));
  }

  return (
    <div style={{ maxWidth: 800, margin: 'auto' }}>
      <Card>
        <CardHeader title={dwelling.location.address} />
        <CardContent>
          {!approved ? (
            <p>
              Tak fordi du oprettede dit lejemål hos os. Vi vil hurtigst muligt
              gennemse og godkende din annonce.
            </p>
          ) : null}
          {token && (
            <div
              style={{
                margin: '10px 0',
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              {!dwelling.active ? (
                <div>
                  <p>Er boligen er blevet ledig igen?</p>
                  <Button
                    primary
                    label={props.i18n('Activate')}
                    onClick={onToggleActive}
                  />
                </div>
              ) : (
                <div>
                  <p>Er boligen blevet udlejet?</p>
                  <Button
                    secondary
                    label={props.i18n('Deactivate')}
                    onClick={onToggleActive}
                  />
                </div>
              )}
              <div>
                <p>Er boligen er stadig ledig?</p>
                <Button
                  primary
                  label={'Forlæng annoncering'}
                  onClick={onExtend}
                />
              </div>
            </div>
          )}
          <br />
          {dwelling.listingType !== 'PREMIUM' && (
            <p>{`Opgrader til ${
              dwelling.listingType === 'STANDARD' ? 'plus' : 'premium'
            } og få dit lejemål ud til endnu flere personer`}</p>
          )}
        </CardContent>
      </Card>
      {window.__cfg.paylike && (
        <PaymentTable
          mutationOptions={mutationOptions}
          dwelling={dwelling}
          title={'Udvid din annoncering'}
          onPayment={updateDwelling}
        />
      )}
      {!token && (
        <div
          style={{
            margin: '10px 0',
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Button
            variant="text"
            to={'/dwellings/'}
            label={'Tilbage til mine lejmål'}
          />
          {!['PLUS', 'PREMIUM'].includes(dwelling.listingType) ? null : (
            <Button
              variant="text"
              to={'/dwellings/' + dwelling.id}
              label={'Opdatere kontaktformer'}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default i18n(connect(() => ({}), { toggleActivation })(StatusPreview));